import { render } from "./AR.vue?vue&type=template&id=b5993a82&scoped=true"
import script from "./AR.vue?vue&type=script&lang=js"
export * from "./AR.vue?vue&type=script&lang=js"

import "./AR.vue?vue&type=style&index=0&id=b5993a82&lang=scss&scoped=true"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5993a82"]])

export default __exports__